import { Run } from "@quantizr-engineering/common/types/run";
import {
  ExpenseTag,
  ExpenseTagType,
  Show,
  showsForRun,
} from "@quantizr-engineering/common/types/show";
import { calculateRunFigures } from "@quantizr-engineering/common/math/live";

export interface RunExpenseDataRow {
  run: { name: string; id: number };
  runWalkout: number;
  name: string;
  tag: ExpenseTagType;
  cost: number;
  actualCost: number;
  notes: string;
}

export class RunExpenseDataRowAdapter {
  toContracts(runs: Run[], shows: Show[]): RunExpenseDataRow[] {
    const rows: RunExpenseDataRow[] = [];

    runs.forEach((run) => {
      if (!run.expenses?.length) return;
      const runShows = showsForRun(shows, run);
      const runWalkout = calculateRunFigures(run, runShows).walkoutActual;
      run.expenses.forEach((expense) => {
        const row: RunExpenseDataRow = {
          run: {
            name: run.name,
            id: run.id ?? 0,
          },
          runWalkout,
          name: expense.name,
          tag: expense.tag ?? ExpenseTag.MISC,
          cost: (expense.cost ?? 0) * (expense.quantity ?? 1),
          actualCost: expense.actualCost ?? 0,
          notes: expense.notes ?? "",
        };
        rows.push(row);
      });
    });

    return rows;
  }
}
